// :cow: Cosmose CONFIDENTIAL :iso:
export enum Language {
  english = 'en',
  chinese = 'cn',
  japanese = 'jp',
}
